import {
  HttpClient,
  HttpContext,
  HttpContextToken,
  HttpHandler,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core/types';
import { FetchResult } from '@apollo/client/link/core/types';
import { Apollo, QueryRef } from 'apollo-angular';
import { HttpLink, HttpLinkHandler } from 'apollo-angular/http';
import { Observable } from 'rxjs';
import { tokenStorageName } from '../../models/resources/common';

@Injectable({
  providedIn: 'root',
})
export class GraphqlService {
  constructor(private apollo: Apollo) {}

  private logout(): void {
    localStorage.removeItem(tokenStorageName);
    location.reload();
  }

  private redirectToLogin(): void {
    this.logout();
  }

  /**
   * Sends query request to GraphQL server.
   * @param query
   * @param variables
   */
  public query<T>(query: any, variables: any = null): Promise<FetchResult<T>> {
    return new Promise<FetchResult<T>>((resolve, reject) => {
      this.apollo
        .query({
          query: query,
          variables: variables,
          errorPolicy: 'all',
          fetchPolicy: 'no-cache',
        })
        .subscribe(
          (data) => {
            // If not authorized error redirect to login.
            if (
              data.errors != undefined &&
              data.errors.find(
                (x) => x.extensions?.code == 'AUTH_NOT_AUTHORIZED'
              ) != undefined
            ) {
              this.redirectToLogin();
            }
            resolve(data as FetchResult<T>);
          },
          (error) => {
            resolve(error.networkError);
          }
        );
    });
  }

  /**
   * Sends query request to GraphQL server.
   * @param query
   * @param variables
   */
  public watchQuery<T>(
    query: any,
    variables: any = null,
    ignoreLoadingBar: boolean = false
  ): QueryRef<unknown, any> {
    return this.apollo.watchQuery({
      query: query,
      variables: variables,
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    });
  }

  /**
   * Send mutation request to GraphQL server.
   * @param mutation
   * @param variables
   */
  public mutate<T>(
    mutation: any,
    variables: any = null
  ): Promise<FetchResult<T>> {
    return new Promise<FetchResult<T>>((resolve, reject) => {
      this.apollo
        .mutate({
          mutation: mutation,
          variables: variables,
          errorPolicy: 'all',
          fetchPolicy: 'no-cache',
        })
        .subscribe(
          (data) => {
            // If not authorized error redirect to login.
            if (
              data.errors != undefined &&
              data.errors.find(
                (x) => x.extensions?.code == 'AUTH_NOT_AUTHORIZED'
              ) != undefined
            ) {
              this.redirectToLogin();
            }
            resolve(data as FetchResult<T>);
          },
          (error) => {
            resolve(error.networkError);
          }
        );
    });
  }
}
